<script setup>
    import { useScheduleItemStore } from "@/stores/ScheduleItemStore"

    const store = useScheduleItemStore()

    const clearFilters = () => {
        store.clearAllFilters()
    }
</script>
<template>
    <button
        class="clear-all-filters"
        @click.prevent="clearFilters()"
    >Clear the filter <svg class="svgicon"><use xlink:href="#svg-filter-off"></use></svg></button>
</template>



